import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EducationDetailsService {

  constructor(public http:HttpClient) { }

  public getEducationDetails(): Observable<any>{
    return this.http.get(environment.BASE_URL_PROFILE+"education/getEducationDetails")
  }

  
  
}
